import palette from '../palette';
import typography from '../typography';

export default {
  root: {
    ...typography.body1,
    padding: '8px 12px',
    borderBottom: `1px solid ${palette.divider}`
  },
  head: {
    fontSize: 12,
    fontWeight: 600,
    color: palette.text.secondary,
    whiteSpace: 'nowrap'
  }
};
